// extracted by mini-css-extract-plugin
export default {"modal":"qda-z","modalContent":"rda-z","footer":"sda-z","cancelBtn":"tda-z","disabled":"uda-z","formWrapper":"vda-z","fade":"wda-z","fade-in":"xda-z","iframe":"yda-z"};